export default __webpack_public_path__ + "static/media/linkedInLight.9f4f9062.svg";